document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.add-to-cart-collection');

  buttons.forEach((button) => {
    button.addEventListener('click', function () {
      const productId = this.getAttribute('data-variant-id');
      const planId = this.getAttribute('data-plan-id');
      
      if (!productId) {
        console.error('No product ID found on button.');
        return;
      }

      this.setAttribute('disabled', 'disabled');
      this.classList.add('loading');

      const formData = {
        items: [
          {
            id: parseInt(productId),
            selling_plan: planId,
            quantity: 1,
          },
        ],
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          this.removeAttribute('disabled');
          this.classList.remove('loading');
          window.quickCart.updateAndOpen();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  });
});
